import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["country", "type"];
  static values = {
    url: String
  };

  connect() {
    // Fetch initial requirements if a country is already selected
    // Use setTimeout to ensure TomSelect has initialized first
    setTimeout(() => {
      if (this.hasCountryTarget && this.countryTarget.value) {
        this.fetchRequirements();
      }
    }, 100);
  }

  change() {
    this.fetchRequirements();
  }

  async fetchRequirements() {
    const countryCode = this.hasCountryTarget ? this.countryTarget.value : null;
    const numberType = this.hasTypeTarget ? this.typeTarget.value : null;

    if (!countryCode) {
      return;
    }

    if (!this.urlValue) {
      console.error("[PortRequirements] URL value not set");
      return;
    }

    const params = new URLSearchParams();
    params.append("country_code", countryCode);
    if (numberType) {
      params.append("number_type", numberType);
    }

    try {
      const response = await fetch(`${this.urlValue}?${params.toString()}`, {
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector("[name=\"csrf-token\"]")?.content
        }
      });

      if (response.ok) {
        const html = await response.text();
        Turbo.renderStreamMessage(html);
      } else {
        console.error("[PortRequirements] Server returned error:", response.status);
      }
    } catch (error) {
      console.error("[PortRequirements] Failed to fetch requirements:", error);
    }
  }
}
